import gql from 'graphql-tag';

export type CreateApplePayMerchantSessionMutationVariables = {
  input: {
    url: string;
  };
};

export type ApplePayMerchantSession = {
  epochTimestamp: number;
  expiresAt: number;
  merchantSessionIdentifier: string;
  nonce: string;
  domainName: string;
  displayName: string;
  signature: string;
};

export type CreateApplePayMerchantSessionMutation = {
  applePayMerchantSession: ApplePayMerchantSession;
};

export const CREATE_APPLE_PAY_MERCHANT_SESSION = gql`
  mutation CreateApplePayMerchantSession($input: CreateApplePayMerchantSessionMutationVariables!) {
    applePayMerchantSession(input: $input)
      @rest(
        type: "RestCreateApplePayMerchantSession"
        endpoint: "self"
        path: "/apple-session"
        method: "POST"
      ) {
      displayName
      domainName
      epochTimestamp
      expiresAt
      merchantIdentifier
      merchantSessionIdentifier
      nonce
      operationalAnalyticsIdentifier
      signature
    }
  }
`;
